import { CurrencyCircleDollar, Prohibit } from "@phosphor-icons/react";

const money = (amount) => new Intl.NumberFormat("en-MY", { style: "currency", currency: "MYR", maximumFractionDigits: 0 }).format(amount);

export default function LoanTable({ loans, onRepayment, onBlacklist, mode = "all" }) {
  const rows = mode === "collections" ? loans.filter((loan) => loan.status === "due") : mode === "blacklist" ? loans.filter((loan) => loan.status === "blacklisted") : loans;
  return <div className="table-wrap" data-testid={`${mode}-loans-table`}>
    <table>
      <thead><tr><th>Borrower</th><th>Product</th><th>Officer</th><th>Due date</th><th className="amount">Outstanding</th><th>Status</th><th aria-label="Actions" /></tr></thead>
      <tbody>{rows.map((loan) => <tr key={loan.id} data-testid={`loan-row-${loan.id}`}>
        <td><strong>{loan.borrower_name}</strong><span>{loan.borrower_phone}</span></td>
        <td>{loan.product_name}<span>{loan.term_months} months · {loan.interest_rate}%</span></td>
        <td>{loan.owner_name}</td><td>{loan.next_due_date}</td><td className="amount">{money(loan.outstanding)}</td>
        <td><span className={`status status-${loan.status}`} data-testid={`loan-status-${loan.id}`}>{loan.status}</span></td>
        <td className="actions">
          {loan.status !== "paid" && (loan.status !== "blacklisted" || mode === "blacklist") && (
            <button
              onClick={() => onRepayment(loan)}
              data-testid={(
                loan.status === "blacklisted"
                  ? `record-blacklisted-repayment-${loan.id}`
                  : `record-repayment-${loan.id}`
              )}
              title="Record payment"
              aria-label={`Record repayment for ${loan.borrower_name}`}
            >
              <CurrencyCircleDollar size={21} />
            </button>
          )}
          {loan.status !== "blacklisted" && loan.status !== "paid" && (
            <button
              onClick={() => onBlacklist(loan)}
              data-testid={`blacklist-loan-${loan.id}`}
              title="Blacklist loan"
              aria-label={`Blacklist ${loan.borrower_name}`}
            >
              <Prohibit size={20} />
            </button>
          )}
        </td>
      </tr>)}</tbody>
    </table>
    {rows.length === 0 && <div className="empty-state" data-testid="empty-loans-state">No matching loans in this view.</div>}
  </div>;
}